import loglevel from "loglevel";

export const appInitLogging = () => {
  const originalFactory = loglevel.methodFactory;
  loglevel.methodFactory = (methodName, logLevel, loggerName) => {
    const originalMethod = originalFactory(methodName, logLevel, loggerName);
    return (...message: unknown[]) => {
      if (loggerName) {
        originalMethod(`[${loggerName.toString()}]`, ...message);
      } else {
        originalMethod(...message);
      }
    };
  };
  // this is needed to apply the new methodFactory
  loglevel.setLevel(loglevel.getLevel());
};
